import type { RootState } from 'src/redux/store'

export const selectPreviewMode = (state: RootState): boolean =>
  state['@customisation'].data.previewMode

export const selectSections = (state: RootState): Record<string, unknown> =>
  state['@customisation'].data.sectionSettingData.sections

export const selectSiteSettingData = (
  state: RootState
): Customisation.SiteSettingData => state['@customisation'].data.siteSettingData

export const selectSectionSettingData = (
  state: RootState
): Customisation.SectionSettingData =>
  state['@customisation'].data.sectionSettingData

export const selectCurrentAction = (state: RootState) =>
  state['@customisation'].data.currentAction

export const selectThemeSettingData = (state: RootState): Customisation.ThemeSettingData =>
  state['@customisation'].data.themeSettingData
